const formatDate = date => {
  if (!date && typeof date !== "string") return null;
  const parts = date.split("-");
  return `${parts[1]}/${parts[2]}/${parts[0]}`;
};

export default formatDate;
